import { INTEGRATION_PROVIDERS, IntegrationProvidersSchema } from '@vy/types';
import type { IntegrationProviders, IntegrationSettings } from '@vy/types';
import { raise, validateNotNullOrUndefined } from '@vy/utils';
import React from 'react';
import { useIntegrationSettings } from '../../../../../hooks/requests/use-integration-settings';
import { HubspotConfiguration } from './configuration-tab-content-components/HubspotConfiguration';
import { IntegrationsSettings } from '@vy/integrations-types';

export type ConfigurationTabContentProps = {
  provider: IntegrationProviders;
};

export const ConfigurationTabContent: React.FC<ConfigurationTabContentProps> = ({ provider }) => {
  const integrationProvider = IntegrationProvidersSchema.parse(provider);
  const { data: integrationData } = useIntegrationSettings(integrationProvider);

  validateNotNullOrUndefined(integrationData, 'integrationData');

  const { integrationSettings } = integrationData;

  return (
    <div className="h-screen min-h-fit bg-[#F6F9FA]">
      <div className="relative flex h-fit min-h-fit flex-col gap-5">
        {renderConfigurationComponent(integrationSettings)}
      </div>
    </div>
  );
};

const renderConfigurationComponent = (
  settings: IntegrationSettings | IntegrationsSettings,
) => {
  const { integrationProvider, integrationConfiguration } = settings;

  switch (integrationProvider) {
    //TODO: Need to refactor this to use the new components
    case INTEGRATION_PROVIDERS.hubspot:
      return <HubspotConfiguration configuration={integrationConfiguration} />;
    default:
      return raise('Not implemented');
  }
};
